module.exports = __webpack_public_path__ + "fd1c498d09f3df7291e331e939f3ea78.svg";